import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';
import { useUser } from '../../context/UserContext';
import iq_api_v2 from '../../services/iqApiV2';

// HeatMap Component
import HeatMap from './HeatMap';

const UserDashboard = () => {

  useAuth(); // Ensure user is authenticated
  const { user } = useUser();

  const [analyticsPageUrl, setAnalyticsPageUrl] = useState("");

  useEffect(() => {
    const getAnalyticsUrl = async () => {
      try {
        const result = await iq_api_v2.post('/analytics/get_token');
        if (result?.status === 200) {
          setAnalyticsPageUrl(result.data);
        }
      } catch (error) {
        console.error("Error fetching analytics URL:", error);
      }
    };

    getAnalyticsUrl();
  }, [user]);

  return (
    <div className="add_user_wrapper min-height-600">
      <div className="container-fluid mt-3">

        {/* If SUPER_ADMIN and URL exists → Show Analytics iframe */}
        {analyticsPageUrl && user?.role_key === 'SUPER_ADMIN' && (
          <div className="row">
            <div className="col-md-12">
              <iframe
                id="myFrame"
                src={analyticsPageUrl}
                frameBorder="0"
                width="100%"
                height="1450"
                allowTransparency="true"
                title="Analytics"
              ></iframe>
            </div>
          </div>
        )}

        {/* Always show HeatMap below */}
        {/* <div className="row mt-4">
          <div className="col-12">
            <HeatMap />
          </div>
        </div> */}

      </div>
    </div>
  );
};

export default UserDashboard;
